export type GeoCoordinate = { lat: number, lng: number };

export class GoogleMapsService {

    constructor(private apiKey: string) {
    }

    loadApi(): Promise<void> {
        return new Promise<void>(resolve => {
            if (document.getElementById('GoogleMapsAPIScript')) return resolve();

            const script = document.createElement('script');
            script.defer = true;
            script.id = "GoogleMapsAPIScript"
            script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places&callback=onGoogleMapsApiLoaded`;
            document.body.appendChild(script)

            window.onGoogleMapsApiLoaded = () => resolve();
        })
    }

    public find(query: string): Promise<google.maps.places.QueryAutocompletePrediction[]> {
        return new Promise((resolve, reject) => {

            if (!query) return reject();

            const autocompleteService = new google.maps.places.AutocompleteService()
            autocompleteService.getQueryPredictions({
                    input: query,
                    location: new google.maps.LatLng(51, 10),
                    radius: 1000
                },
                (results: google.maps.places.QueryAutocompletePrediction[], status: google.maps.places.PlacesServiceStatus) =>
                    (status == google.maps.places.PlacesServiceStatus.OK) ? resolve(results) : reject()
            );
        });
    }

    public geoCodePlaceId(placeId: string): Promise<google.maps.GeocoderResult[]> {
        return new Promise((resolve, reject) => {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode(
                {placeId},
                (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) =>
                    (status == google.maps.GeocoderStatus.OK) ? resolve(results) : reject()
            )
        })

    }
}
